var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pane flex"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title ? _vm.title : _vm.configData.name)+" ")]),_c('div',{staticClass:"pane-center center"},[_vm._t("center")],2),_c('div',{staticClass:"extra"},[_vm._t("extra")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }